import React, { Suspense, lazy } from 'react';
import { LandingPage } from './pages/LandingPage';
import { MetaPixel } from './components/MetaPixel';
// Loaded lazily so its animation library stays out of the critical bundle.
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <LandingPage data-id="element-1" />
      <Suspense fallback={null} data-id="element-2">
        <PurchasePopup data-id="element-3" />
      </Suspense>
    </>;
}